import {
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../../types/lists/listTypes';

export const hotelsTableColumns: ITableHeaderColumn[] = [
    {
        id: 'Name',
        labelText: 'name',
        titleText: 'name',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'PublishStatus',
        labelText: 'status',
        titleText: 'status',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey:
                'Hotel/ZitoneoPublishStatus/ZitoneoPublishStatusType/Caption',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'LastChange',
        labelText: 'last_updated',
        titleText: 'last_updated',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Hotel/HotelZitoneoChange/ChangeDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
    {
        id: 'Actions',
        labelText: '',
        titleText: '',
    },
];
